// extracted by mini-css-extract-plugin
export default {"searchBar":"AdminSearch_searchBar__ExD1U","searchBtn":"AdminSearch_searchBtn__ECj3k","clearBtn":"AdminSearch_clearBtn__H-XQu"};